import type { PropTypes } from './ProfileSummaryItem.types';
import type { ReactElement } from 'react';

import { Card, Flex, Skeleton, Text } from '@rango-dev/whale';
import React from 'react';

const SKELETON_VALUE_WIDTH = '151px';
const SKELETON_VALUE_HEIGHT = '28px';

export function ProfileSummaryItem(props: PropTypes): ReactElement {
  const { title, icon } = props;

  return (
    <Card variant="surface" size="3">
      <Flex align="center" gap="2">
        {icon}
        <Flex direction="column" gap="1" align="start">
          <Text size="2" color="gray">
            {title}
          </Text>
          {props.loading ? (
            <Skeleton width={SKELETON_VALUE_WIDTH} height={SKELETON_VALUE_HEIGHT} />
          ) : (
            <Text size="5" weight="bold">
              {props.value}
            </Text>
          )}
        </Flex>
      </Flex>
    </Card>
  );
}
